<template>
  <div>

    <div class="card card-body p-0" id="card_body" style="border-radius: 10px">
      <quick-task-filters @skeletonLoader="setskeletonLoader" @setPage="setPage"
                          @selectQuickTaskTab="selTab" @setQuickTaskStatus="setStatus"
                          @update-parent-filters="updateParentFilters" @set-search="setSearch"
                          id="quick_task"></quick-task-filters>
      <quick-tasks-table :quickTasks="quickTasks" :total_quick_task="totalTickets" :total_rows="totalRows"
                         :displayed_tickets="displyedRows" :totalPages="totalPages" :page="page" :selTab="sel_tab"
                         :setskeletonLoader="displayLoader" @setPage="setPage" :setStatus="status"></quick-tasks-table>
    </div>
  </div>
</template>

<script>
import helpers from "@/helpers.js";
import quickTaskFilters from "@/components/QuickTask/quick_task_filters.vue";
import quickTasksTable from "@/components/QuickTask/quick_task_table.vue";
import VueSkeletonLoader from 'skeleton-loader-vue';

export default {
  components: {
    quickTasksTable, quickTaskFilters, VueSkeletonLoader,
  },

  data: function () {
    return {
      page: 0,
      status: 0,
      sel_tab: 0,
      total_quick_task: 0,
      total_task_perpage: 0,
      displayed_quick_task: 0,
      displayLoader: false,
      filters: {},
      search: ''
    };
  },

  computed: {

    type() {
      return this.$route.meta.taskType;
    },

    quickTasks: function () {
      return this.$store.getters["quick_task/tasks"];
    },
    totalPages: function () {
      return this.$store.getters["quick_task/totalPages"];
    },
    totalTickets: function () {
      return this.$store.getters["quick_task/totalTask"];
    },
    displyedRows: function () {
      return this.$store.getters["quick_task/taskPerPage"];
    },
    totalRows: function () {
      return this.$store.getters["quick_task/totalRows"];
    },
  },

  created: function () {
    if (localStorage.getItem("quickTaskTab") != null) {
      localStorage.getItem("quickTaskTab") == '0';
      this.setStatus('0');
      this.selTab('0');
      //  this.setskeletonLoader(false);
    }
    window.addEventListener('scroll', this.handleScroll);
    this.page = helpers.getPageQuery();

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function () {
    if ($("#navbarResponsive").hasClass("show")) {
      $("#navbarResponsive").toggleClass("show");
    }
    this.getRecords();
  },

  watch: {
    page: function (val) {
      let status_val = this.status;
      this.setskeletonLoader(true);
      this.$store.dispatch("quick_task/getAllTask", [val, status_val, this.status, this.filters])
          .then(() => {
            this.setskeletonLoader(false);
          });
    },
    $route(to, from) {
      this.getRecords();
    }
  },

  methods: {
    setPage(page) {
      this.page = page;
    },
    setStatus(status) {
      this.status = status;
      localStorage.setItem("quickTaskTab", status);
    },
    selTab(event) {
      this.sel_tab = event;
      localStorage.setItem("quickTaskTab", event);
    },
    setskeletonLoader(event) {
      this.displayLoader = event;
      this.$forceUpdate();
    },
    handleScroll(event) {
      $(".hide-menu").removeClass('show');
    },

    updateParentFilters: function (value) {
      this.filters = value;
    },

    setSearch: function (value) {
      this.search = value
    },

    getRecords() {
      this.displayLoader = true;

      const type = this.type === "myTask" ? 0 : 1;

      this.$store.dispatch("quick_task/getAllTask", [1, this.status, this.search, this.filters, type])
          .then(() => {
            this.setskeletonLoader(false);
          }).catch(() => {
            this.setskeletonLoader(false);
          });
    },

  },
};
</script>
<style scoped>
@media (min-width: 320px) and (max-width: 680px) {
  #card_body {
    width: 100% !important;
    border-radius: 0px !important;
    /* width: 108% !important;
    border-radius: 0px !important;
    margin-left: -17px; */
  }

  #quick_task {
    /* bottom: 0 !important; */
    position: fixed !important;
    width: 100% !important;
    z-index: 2;
  }

}
</style>